export default __webpack_public_path__ + "images/fa91ecdc5c7525aa60feef1b580004ff-1_4K_1920x544.jpg";